import { render, staticRenderFns } from "./dataPermissionManagement.vue?vue&type=template&id=786b0137&scoped=true&"
import script from "./dataPermissionManagement.vue?vue&type=script&lang=js&"
export * from "./dataPermissionManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786b0137",
  null
  
)

export default component.exports